export default __webpack_public_path__ + "components/wind-icon/static/SE@2x-2a929ef75dbd6eaf4597601ef9e5436c.png";